import styled from 'styled-components';
import { color } from '@libs/theme/mixins';
export default styled.div `
	height: 100%;
	background-color: ${color(['gray', '000'])};
`;
